export class FormType {
  id: number
  name: string
  default_form_data: string
  
  constructor() {
  }

  static buildOne(obj: any): FormType {
    let target: FormType = Object.assign(new FormType(), obj)
    return target
  }

  static buildMany(objs: any[]): FormType[] {
    const lobjs = []
    for (const i in objs) {
      if (objs.hasOwnProperty(i)) {
        lobjs.push(FormType.buildOne(objs[i]))
      }
    }
    return lobjs
  }
}

